var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "document-form" },
    [
      _c("TabHeaderComponent", {
        staticClass: "tab-header",
        attrs: { buttons: _vm.buttons, title: _vm.formTitle },
        on: {
          closeForm: _vm.onCloseForm,
          saveForm: _vm.onSaveForm,
          removeItem: _vm.onRemoveItem,
        },
      }),
      _vm.formSchema
        ? _c("FormGeneratorComponent", {
            key: _vm.componentKey,
            attrs: {
              schema: _vm.formSchema,
              fieldValues: _vm.fieldValues,
              context: _vm.context,
              validateOnLoad: "",
            },
            on: { saveFormData: _vm.onChangeFormFieldValue },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }